/*
 * @描叙: 表计接口 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-02-21 09:50:30 
*/

import { $post, $get } from '@/utils/http'
import Service from './Service'

// 获取表计读数
Service.getTerminalInfo = async function (params) {
    let request = {}
    // 表计ID
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/devices/terminalcurrentreadingsbytid', request);
    return Service.handleCommonError(data)
}


//根据建筑ID列表获取表记花费
Service.getTerminalByidlist = async function (params) {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    if (!request['project_sys_id']) return;
    // 建筑list
    request['ids'] = params.ids;
    //是否为房间
    request['is_house'] = params.is_house;
	//业主名字
	request['household_name'] = params.household_name;
	//开始时间
	request['from'] = params.from;
	//结束时间
	request['to'] = params.to;
	//页数
	request['page_num'] = params.page_num;
	//条数
	request['page_sum'] = params.page_sum;
	
    let data = await $get('/ucenter/v2/base/terminalcost/bidlist', request, true);
    return Service.handleCommonError(data)
}
//根据建筑ID列表获取表记花费
Service.getTerminalBynobill = async function (params) {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    if (!request['project_sys_id']) return;
    // 建筑list
    request['ids'] = params.ids;
    //是否为房间
    request['is_house'] = params.is_house;
	//业主名字
	request['household_name'] = params.household_name;
	//开始时间
	request['from'] = params.from;
	//结束时间
	request['to'] = params.to;
	//页数
	request['page_num'] = params.page_num;
	//条数
	request['page_sum'] = params.page_sum;
	
    let data = await $get('/ucenter/v2/base/terminalcost/nobill', request, true);
    return Service.handleCommonError(data)
}
//生成账单generate
Service.Generate = async function (params) {
    let request = {}
	request['household_id'] = params.household_id;
	//开始时间
	request['from'] = params.from;
	//结束时间
	request['to'] = params.to;
	
    let data = await $post('/ucenter/v2/base/bill/house/bill/generate', request);
    return Service.handleCommonError(data)
}
//查询房间账单
Service.getHouseBill = async function (params) {
    let request = {}
    // 项目Id
    request['project_sys_id'] = Service.getProjectSystemId();
    if (!request['project_sys_id']) return;
    // 建筑list
    request['ids'] = params.ids;
    //是否为房间
    request['is_house'] = params.is_house;
	//是否缴费
	request['pay_status'] = params.pay_status;
	//业主名字
	request['household_name'] = params.household_name;
	//开始时间
	request['from'] = params.from;
	//结束时间
	request['to'] = params.to;
	//页数
	request['page_num'] = params.page_num;
	//条数
	request['page_sum'] = params.page_sum;
	
    let data = await $get('/ucenter/v2/base/bill/house/bill', request, true);
    return Service.handleCommonError(data)
}

//房间账单缴费payfor
Service.PayFor = async function (params) {
    let request = {}
    // 房间号
    request['bill_house_id'] = params.bill_house_id;

    let data = await $post('/ucenter/v2/base/bill/house/bill/payfor', request);
    return Service.handleCommonError(data)
}







// 根据房间号获取表计读数
Service.getTerminalcurrentreadings = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
    // 业主名称
    request['name'] = params.name;
    // 房间号
    request['housename'] = params.housename;

    let data = await $post('/ucenter/v2/devices/terminalcurrentreadings', request);
    return Service.handleCommonError(data)
}

// 根据项目ID获取表计
Service.getTerminalcurrentreadingsbypid = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;

    // 表记序列号
    request['terminalserial'] = params.deviceSerial;
    // 集控器ID
    request['collector_id'] = params.collector_id;
    // 在线状态（0所有，1在线，2离线）
    request['online_status'] = params.status || 0;
    // 开机状态（0关机，1开机，255所有）
	request['setting_power_on'] = params.power_on?params.power_on:(params.power_on === 0? 0: 255);
    // 模式（0正常模式，1调试模式，255所有）
    request['factory_mode'] = params.factory_mode?params.factory_mode:params.factory_mode ===0? 0:255;
    // 计费模式（0停止计费，1允许计费，255所有）
    request['allow_charging'] = params.fcu_in_counting?params.fcu_in_counting:params.fcu_in_counting===0? 0:255;
    // 故障（0正常，1故障，255所有）
    request['error'] = params.sys_status?params.sys_status:params.sys_status ===0? 0:255;
    // 楼宇ID
    request['moduleid'] = params.moduleid;

    // 是否是房间ID
    request['is_house'] = params.is_house;

    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get('/ucenter/v2/devices/terminalcurrentreadingsbypt', request, true);
    return Service.handleCommonError(data)
}


// 根据项目ID获取表计
Service.getnewTerminalcurrentreadingsbypid = async function (params) {
    let request = {}
    // 项目Id
    request['assigned_project_id'] = Service.getProjectSystemId();
    if (!request['assigned_project_id']) return;
	// 楼宇ID
	request['moduleid'] = params.moduleid;
    // 表记序列号
    request['terminalserial'] = params.deviceSerial;
    // 集控器ID
    request['collector_id'] = params.collector_id;
    // 在线状态（0所有，1在线，2离线）
    request['online_status'] = params.status || 0;
    // 开机状态（0关机，1开机，255所有）
	request['setting_power_on'] = params.power_on?params.power_on:(params.power_on === 0? 0: 255);
    // 模式（0正常模式，1调试模式，255所有）
    request['factory_mode'] = params.factory_mode?params.factory_mode:params.factory_mode ===0? 0:255;
    // 计费模式（0停止计费，1允许计费，255所有）
    request['allow_charging'] = params.fcu_in_counting?params.fcu_in_counting:params.fcu_in_counting===0? 0:255;
    // 故障（0正常，1故障，255所有）
    request['error'] = params.sys_status?params.sys_status:params.sys_status ===0? 0:255;
    // 楼宇层级
    request['building_index'] = params.buildingindex;

    // 是否是房间ID
    request['is_house'] = params.is_house;

    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get('/ucenter/v2/devices/terminalcurrentreadingsbypt3', request, true);
    return Service.handleCommonError(data)
}

// 获取多个表计实时读数
Service.getOIDSTerminalreadings = async function (params) {
    let request = {}

    // request['assigned_project_id'] = Service.getProjectSystemId();
    // if (!request['assigned_project_id']) return;
    // OID 集合
    request['oidlist'] = params.oidlist

    let data = await $post('/ucenter/v2/devices/terminalcurrentreadingsbytidlist', request, true);
    return Service.handleCommonError(data)
}

// 根据房间id获取表记入户抄表值
Service.getTerminalvalue = async function (params) {
    let request = {}
    // 房间id 集合
    request['assigned_house_id'] = params.assigned_house_id

    let data = await $post('/ucenter/v2/devices/terminalvalue', request, true);
    return Service.handleCommonError(data)
}

// 批量修改表记的入户抄表值
Service.editTerminalvalue = async function (params) {
    let request = {}
    // 修改的表计读数   oid household_value
    request['householdvaluelist'] = JSON.stringify(params.householdvaluelist)

    let data = await $post('/ucenter/v2/devices/editterminalvalue', request, true);
    return Service.handleCommonError(data)
}

// 根据表记id获取表记入户抄表值
Service.getTerminalValuebytId = async function (params) {
    let request = {}
    // 表计ID
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/devices/terminalvaluebytid', request);
    return Service.handleCommonError(data)
}


// 获取表计信息
Service.getTerminalbyidInfo = async function (params) {
    let request = {}
    // 表计ID
    request['oid'] = params.oid;

    let data = await $post('/ucenter/v2/devices/terminalbyid', request);
    return Service.handleCommonError(data)
}

// 设备故障
Service.getDeviceFault = async function (params) {
    let request = {}
    // 项目Id
    request['project_id'] = Service.getProjectSystemId();
    if (!request['project_id']) return;
    // 	开始时间
    request['start_time'] = params.start_time;
    // 	结束时间
    request['end_time'] = params.end_time;
    // 	第几页
    request['page_num'] = params.page_num;
    // 	一页几条数据
    request['page_sum'] = params.page_sum;

    let data = await $get('/ucenter/v2/devices/device_fault', request);
    return Service.handleCommonError(data)
}

// 获取设备统计
Service.getStatistic = async function () {
    let request = {}
    // 项目Id
    request['project_id'] = Service.getProjectSystemId();
    if (!request['project_id']) return;

    let data = await $get('/ucenter/v2/devices/statistic', request);
    return Service.handleCommonError(data)
}

// 获取表计类型
Service.getTerminalType = async function () {
    return [
        {
            label: '温控器',
            value: 1
        },
        {
            label: '风柜',
            value: 2
        },
        {
            label: '热量表',
            value: 3
        },
        {
            label: 'PLC',
            value: 4
        },
    ]
}

// 获取表计型号配置
Service.getDeviceConfig = async function () {
    return []
}




